<template>
  <div class="left_menu_div">
    <div class="left_menu_div2">
      <ul class="two_menu_ul">
        <li
          v-for="(item, index) in leftMenuList"
          :key="index"
          class="two_menu_li"
        >
          <!-- 判断该菜单是生效状态并且是公有菜单才显示 -->
          <template v-if="item.enableSign == 0 && item.menuSign == 1">
            <div
              :class="[
                'two_li_div',
                { two_menu_div_sel: item.menuCode === twoMenuSelectVal },
              ]"
              @click="twoMenuSelectClick(item)"
              :title="item.menuName"
            >
              <div class="menu_name">
                <span>{{ item.menuName }} </span>
                <i
                  v-show="!item.isSel"
                  :class="[
                    'iconfont',
                    'icon-daohangjiantou1',
                    { icon_sel: item.menuCode === twoMenuSelectVal },
                  ]"
                ></i>
                <i
                  v-show="item.isSel"
                  :class="[
                    'iconfont',
                    'icon-daohangjiantou1',
                    { icon_sel: item.menuCode === twoMenuSelectVal },
                  ]"
                  style="transform: rotate(90deg)"
                ></i>
              </div>
            </div>
            <ul class="three_menu_ul" v-if="item.children">
              <template v-for="(thItem, index) in item.children">
                <!-- 判断该菜单是生效状态 -->
                <li
                  @click="threeMenuSelectClick(thItem)"
                  :key="index"
                  :title="thItem.menuName"
                  class="three_menu_box"
                  v-if="thItem.enableSign == 0 && thItem.menuSign == 1"
                >
                  <div
                    :class="[
                      'three_menu_li',
                      {
                        three_menu_li_sel:
                          thItem.menuCode === threeMenuSelectVal,
                      },
                    ]"
                  >
                    <i :class="['iconfont', thItem.icon]"></i>
                    <p>{{ thItem.menuName }}</p>
                  </div>
                </li>
              </template>
            </ul>
          </template>
        </li>
        <template v-if="integrSysMenu">
          <li
            v-for="item in statList"
            :key="item.staIndex"
            class="two_menu_li"
            v-show="topMenuSelectVal == integrSysMenu[0].menuCode"
          >
            <div
              @click="statSelectClick(item)"
              :title="item.stationName"
              :class="['two_li_div', { two_menu_div_sel: item.id == statId }]"
            >
              <div class="menu_name">
                <!-- <span>{{ item.stationName }} </span> -->
                <span>{{ item.abbreviation }} </span>
                <i
                  :class="[
                    'iconfont',
                    'icon-daohangjiantou1',
                    { icon_sel: item.id == statId },
                  ]"
                ></i>
              </div>
            </div>
          </li>
        </template>
      </ul>
    </div>
    <div class="bottom_winicon">
      <div
        class="left_menu_div3"
        :style="{
          backgroundImage: `url(${
            isHovered ? leftmenuHoverImage : leftMenuImage
          })`,
        }"
      ></div>
      <div class="left_menu_div4"></div>
      <div
        class="left_menu_div5"
        :style="{
          backgroundImage: `url(${
            isHovered ? leftMenuThreeHoverImage : leftMenuThreeImage
          })`,
        }"
      ></div>
      <div class="left_menu_div6"></div>
      <div
        class="left_menu_div7"
        @mouseover="onMouseOver"
        @mouseout="onMouseOut"
        @click.stop="openFunctionPopup"
      ></div>
      <transition name="popup">
        <div class="popup_div" v-if="showFunctionPopup" ref="popup">
          <functionPopup @closePopup="closePopup"></functionPopup>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import myApi from "@/util/my-api";
import myConst from "../../util/my-const";
import fun from "@/util/util";
import functionPopup from "@/components/iems/function-popup.vue";
export default {
  name: "left-menu",
  data() {
    return {
      // statList: [],
      showFunctionPopup: false,

      isHovered: false,
      leftMenuImage: require("@/assets/images/iems/left_menu_yuanxin.png"),
      leftmenuHoverImage: require("@/assets/images/iems/left_menu_yuanxin_hover.png"),
      leftMenuThreeImage: require("@/assets/images/iems/left_menu_yuan_three.png"),
      leftMenuThreeHoverImage: require("@/assets/images/iems/left_menu_yuan_three_hover.png"),
      show: false,
      close: false,
    };
  },
  components: {
    functionPopup,
  },
  computed: {
    ...mapState("integSysMenu", [
      "leftMenuList",
      "integrSysMenu",
      "topMenuSelectVal",
      "twoMenuSelectVal",
      "threeMenuSelectVal",
      "statList",
    ]),
    ...mapState("statMenu", ["statId", "statMenuSeVal", "statMenuList"]),
  },
  watch: {
    twoMenuSelectVal: {
      handler(val) {
        //监听二级菜单的变化
        if (val) {
          if (!fun.isNull(this.leftMenuList)) {
            let arr = this.leftMenuList.filter((item) => {
              return item.menuCode == val;
            });
            if (arr.length > 0) {
              if (arr[0].menuType == myConst.menuType.menu) {
                //当菜单的类型是菜单时,跳转路由
                this.$router.push({ path: arr[0].routerPath });
              } else if (arr[0].menuType == myConst.menuType.openPageMenu) {
                //当菜单类型是打开新页面时,跳转路由
                // window.open(arr[0].routerPath, "_blank");
                this.$router.push({ path: arr[0].routerPath });
              }
              //设置三级菜单并设置选中项(二级菜单切换如果有三级菜单,三级菜单必会切换,二级菜单切换之后,选中三级菜单的第一个)
              if (arr[0].children && arr[0].children.length > 0) {
                //筛选出生效的三级菜单
                let elableMenu = arr[0].children.filter((x) => {
                  return (
                    x.enableSign == myConst.enableSign.yes &&
                    x.menuType == myConst.menuType.menu
                  );
                });
                //将生效的三级菜单的第一个选中
                this.setThreeMenuSelectVal(elableMenu[0].menuCode); //设置当前三级菜单的选中值(当二级菜单切换,将有三级菜单的第一个菜单选中跳转路由)
                let arr1 = elableMenu.filter((item) => {
                  return item.menuCode == this.threeMenuSelectVal;
                });
                //判断当前的菜单类型是菜单,进行路由的跳转
                if (arr1[0].menuType == myConst.menuType.menu) {
                  this.$router.push({ path: arr1[0].routerPath });
                }
              }
            }
          }
        }
      },
      // immediate:true //页面加载初始就监听
    },
    //监听一级菜单
    topMenuSelectVal: {
      handler(val) {
        if (val) {
          if (this.leftMenuList.length > 0) {
            this.setStatId("");
            this.setStatName("");
          }
          this.setTopMenuSelVal(val); //设置一级菜单的选中值
        }
      },
      // immediate:true //页面加载初始就监听
    },

    //监听三级菜单的变化
    threeMenuSelectVal: {
      handler(val) {
        //因为三级菜单发生变化,目前不知道三级菜单需要跳转的路由
        //当三级菜单发生变化时,根据当前二级菜单的选中值找到对应二级菜单,二级菜单的子集children属性就是对应的三级菜单
        if (val) {
          if (this.leftMenuList) {
            let arr = this.leftMenuList.filter((item) => {
              return item.menuCode == this.twoMenuSelectVal;
            });
            let children = arr[0].children;
            //根据变化的三级菜单id从children里面找到对应的路由
            if (children && children.length > 0) {
              let arr1 = children.filter((item) => {
                return item.menuCode == val;
              });
              //判断当前菜单类型是菜单才进行跳转
              if (arr1[0].menuType == myConst.menuType.menu) {
                this.$router.push({ path: arr1[0].routerPath });
              }
            }
          }
        }
      },
    },
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听
    // document.removeEventListener("click", this.onClickOutside);
  },
  methods: {
    ...mapMutations("integSysMenu", [
      "setTopMenuSelVal",
      "setTwoMenuSelVal",
      "setThreeMenuSelectVal",
    ]),
    ...mapMutations("statMenu", [
      "setStatId",
      "setStatMenuSelVal",
      "setStatMenuList",
      "setStatName",
      "setDevId",
      "setDevType",
    ]),
    ...mapMutations("controlPopover", ["openWarning"]),
    //二级菜单选择事件
    twoMenuSelectClick(item) {
      if (item.menuType == myConst.menuType.openPageMenu) {
        //当菜单类型是打开新菜单时,不用设置二级菜单的选中值,直接跳转页面
        window.open(item.routerPath, "_blank");
        // location.href = item.routerPath
        // this.$router.push({ path: item.routerPath , target:'_blank'});
        //判断当前菜单是不是告警弹窗
      } else if (item.menuCode == myConst.menuCode.alarmCode) {
        this.openWarning();
      } else {
        this.leftMenuList.map((x) => {
          x.isSel = false;
        });
        if (item.children.length > 0) item.isSel = true;
        //更改二级菜单的选中值
        this.setTwoMenuSelVal(item.menuCode);
        this.setStatId("");
        this.setStatName("");
      }
    },

    //三级菜单选择事件
    threeMenuSelectClick(item) {
      //更改三级菜单的选中值
      this.setThreeMenuSelectVal(item.menuCode);
    },

    // 监听点击事件
    onClickOutside(event) {
      // // 判断点击区域是否在弹窗外部
      // if (this.$refs.popup && !this.$refs.popup.contains(event.target)) {
      //   this.showFunctionPopup = false; // 点击外部区域，关闭弹窗
      //   document.removeEventListener('click', this.onClickOutside);
      // }
    },

    //电站选择事件
    statSelectClick(item) {
      //加载该电站的私有菜单,跳转路由
      if (item.id) {
        let data = {
          stationId: item.id,
        };
        this.$axios.post(myApi.getStatAndMenu, data).then((res) => {
          if (res.data.code === myConst.code.success) {
            if (res.data.data.length > 0) {
              this.setTwoMenuSelVal("");
              this.setStatId(item.id);
              this.setStatName(item.stationName);
              this.setStatMenuList(res.data.data);
              this.setStatMenuSelVal(this.statMenuList[0].id);
              this.setDevId(null);
              this.setDevType(null);
              this.$router.push({
                path: this.statMenuList[0].routerPath,
              });
            } else {
              this.$message({
                message: "该电站未配置菜单",
                type: "info",
              });
            }
          } else {
            //// this.$message({ message: res.data.msg, type: "info" });
          }
        });
      }
    },
    // 功能操作图表鼠标移入事件
    onMouseOver() {
      this.isHovered = true;
    },
    onMouseOut() {
      this.isHovered = false;
    },
    
    // "修改密码"弹窗是否打开，用于判断左下角菜单点击除自身外的其他位置是否关闭
    closePopup(e) {
      this.close = e;
    },

    // 打开或者关闭弹窗
    openFunctionPopup() {
      this.showFunctionPopup = !this.showFunctionPopup;
    },
    closeFunctionPopupOnOutsideClick(event) {
      if (
        this.showFunctionPopup &&
        !this.$refs.popup.contains(event.target) &&
        !this.close
      ) {
        this.showFunctionPopup = false;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.closeFunctionPopupOnOutsideClick);
  },
  beforeUnmount() {
    document.removeEventListener(
      "click",
      this.closeFunctionPopupOnOutsideClick
    );
  },
};
</script>

<style scoped lang="scss">
.left_menu_div {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}

.left_menu_div2 {
  width: 100%;
  height: 87%;
  background-image: url("../../assets/images/iems/left_menu_bag_new.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-top: 2rem;
  box-sizing: border-box;
  overflow: auto;
}
.bottom_winicon {
  position: relative;
  width: 100%;
  height: 13%;
  // display: flex;
  // align-items: center;
  .popup_div {
    position: absolute;
    left: 9rem;
    bottom: 6.5rem;
    z-index: 99;
    transform-origin: left bottom;
    animation: grow 0.5s forwards;
  }

  .popup-enter-active,
  .popup-leave-active {
    transition: opacity 0.5s ease;
  }

  .popup-enter,
  .popup-leave-to {
    opacity: 0;
  }

  @keyframes grow {
    0% {
      transform: scale(0);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  /* C关闭时的动画 */
  @keyframes shrink {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(0);
      opacity: 0;
    }
  }

  .popup-leave-active {
    animation: shrink 0.3s forwards;
  }
  .left_menu_div3 {
    position: absolute;
    left: 3.3rem;
    bottom: 4.75rem;
    width: 3.3rem;
    height: 3.3rem;
    /* background-image: url("../../assets/images/iems/left_menu_yuanxin.png"); */
    background-size: 100% 100%;
    background-repeat: no-repeat;
    /* border:1px solid red */
  }
  .left_menu_div4 {
    position: absolute;
    width: 7.8rem;
    height: 8rem;

    left: 1rem;
    bottom: 2.5rem;
    background-image: url("../../assets/images/iems/left_menu_yuan_bag.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    animation: rotate_reverse 10s linear infinite;
    /* cursor: pointer; */
    /* border: 1px solid red; */
  }
  .left_menu_div5 {
    position: absolute;
    width: 5rem;
    height: 5rem;
    left: 2.5rem;
    bottom: 4rem;
    /* background-image: url("../../assets/images/iems/left_menu_yuan_three_hover.png"); */
    background-size: 100% 100%;
    background-repeat: no-repeat;
    animation: rotate_reverse 2s linear infinite;
    /* cursor: pointer; */
    /* border: 1px solid red; */
  }
  .left_menu_div6 {
    position: absolute;
    width: 7.8rem;
    height: 8rem;

    left: 1rem;
    bottom: 2.5rem;

    background-image: url("../../assets/images/iems/left_menu_yuan_one.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    animation: rotate 2s linear infinite;
    /* cursor: pointer; */
    /* border: 1px solid red; */
  }
  .left_menu_div7 {
    position: absolute;
    width: 7.8rem;
    height: 7.8rem;

    left: 1rem;
    bottom: 2.5rem;

    background-image: url("../../assets/images/iems/left_menu_yuan_two.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    animation: rotate_reverse 2s linear infinite;
    cursor: pointer;
    /* border: 1px solid red; */
  }
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes rotate_reverse {
    from {
      transform: rotate(360deg);
    }
    to {
      transform: rotate(0deg);
    }
  }
}

.two_menu_ul {
  width: 100%;
  height: 100%;
  overflow: auto;
}

.two_menu_div_sel {
  color: #fff;
  background-image: url("../../assets/images/iems/but_bat_1_hove_new.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.two_li_div {
  width: 100%;
  height: 5.2rem;
  line-height: 5.2rem;
  font-weight: 500;
  font-size: 1.6rem;
  color: #bbedf5;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 0 2rem;
  box-sizing: border-box;
  .menu_name {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    border-bottom: 0.1rem solid #13344b;
    height: 100%;
    width: 96%;
    span {
      display: inline-block;
      vertical-align: top;
      margin-left: 0.5rem;
      margin-right: 0.5rem;
      width: 13rem;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    i {
      font-size: 1.3rem;
      display: flex;
      margin-right: 1rem;
      color: #77a0ad;
      box-shadow: 0rem 0.1rem 0.3rem 0rem rgba(5, 27, 37, 0.5);
    }
    .icon_sel {
      color: #fff;
    }
  }
}
.two_li_div:hover {
  background-image: url("../../assets/images/iems/but_bat_1_hove_new.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fff;
}
.two_li_div:hover i {
  color: #fff;
}
.two_li_div + ul {
  height: 0;
}

.two_menu_div_sel + ul {
  height: auto;
}

.three_menu_ul {
  width: 80%;
  background-color: rgba(
    0,
    0,
    0,
    0.3
  ); /* IE9、标准浏览器、IE6和部分IE7内核的浏览器(如QQ浏览器)会读懂 */
  margin: 0 auto;
  overflow: hidden;
  border-bottom: 0.1rem solid #13344b;
  .three_menu_box {
    width: 100%;
    height: 4.2rem;
    line-height: 4.2rem;
    text-align: center;
    cursor: pointer;
    .three_menu_li {
      color: #bbedf5;
      width: 100%;
      height: 100%;
    }

    .three_menu_li:hover {
      background-image: url("../../assets/images/iems/three_menu_sel_new.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      color: #fff;
    }

    .three_menu_li_sel {
      color: #fff;
      background-image: url("../../assets/images/iems/three_menu_sel_new.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  .three_menu_box:nth-last-child(1) {
    margin-bottom: 0.3rem;
  }

  .three_menu_box:first-child {
    margin-top: 1rem;
  }
}
</style>
